import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "../../shared/services/app/instance";
import { toast } from "react-toastify";

export const getAppVersions = createAsyncThunk(
  "appVersions/getAll",
  async ({ page = 1, limit = 20, platform, appType, isActive }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ page, limit });
      if (platform) params.append("platform", platform);
      if (appType) params.append("appType", appType);
      if (isActive !== undefined) params.append("isActive", isActive);

      const { data } = await instance.get(`/app/versions?${params.toString()}`);
      return data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Error fetching app versions");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const createAppVersion = createAsyncThunk(
  "appVersions/create",
  async (versionData, { rejectWithValue }) => {
    try {
      const { data } = await instance.post("/app/versions", versionData);
      toast.success("Версію успішно створено");
      return data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating app version");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateAppVersion = createAsyncThunk(
  "appVersions/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await instance.put(`/app/versions/${id}`, data);
      toast.success("Налаштування версії оновлено");
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating app version");
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteAppVersion = createAsyncThunk(
  "appVersions/delete",
  async (id, { rejectWithValue }) => {
    try {
      await instance.delete(`/app/versions/${id}`);
      toast.success("Версію деактивовано");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting app version");
      return rejectWithValue(error.response?.data);
    }
  }
);
